<template>
	<div class="header-add-button">
		<v-menu offset-y>
			<v-btn
				slot="activator"
				:icon="$vuetify.breakpoint.smAndDown"
				dark
				flat
				ripple
			>
				<template v-if="$vuetify.breakpoint.mdAndUp">
					Add
					<v-icon right>add</v-icon>
				</template>
				<v-icon v-else>add</v-icon>
			</v-btn>
			<v-list>
				<v-list-tile
					v-if="$userCan('create_projects')"
					@click="$refs.addProject.show = true"
				>
					<v-list-tile-title>Project</v-list-tile-title>
				</v-list-tile>
				<v-list-tile
					v-if="$userCan('create_reports')"
					@click="$refs.addReport.show = true"
				>
					<v-list-tile-title>Report</v-list-tile-title>
				</v-list-tile>
				<v-list-tile
					@click="$refs.addArticle.show = true"
				>
					<v-list-tile-title>Article</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>
		<AddProject ref="addProject" />
		<AddReport ref="addReport" />
		<AddArticle ref="addArticle" />
	</div>
</template>

<script>
export default {
	components: {
		AddProject: () => import('./AddProject'),
		AddReport: () => import('./AddReport'),
		AddArticle: () => import('./AddArticle'),
	},
}
</script>
